import { Box, Grid } from "@material-ui/core";
import { Typography } from "@mui/material";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as DeleteIcon } from "../../../src/assets/DeleteIcon.svg";
import { ThemeContext } from "../../theme/ThemeContext";
import DialogBox from "./DialogBox";

export default function DeleteDialog(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);

  const handleSubmit = () => {
    handleClose();
    props.handleDelete();
  };

  const handleOpen = () => {
    setOpen(true);
    setDiaLogBoxBlur(true);
  };

  const handleClose = () => {
    setOpen(false);
    setDiaLogBoxBlur(false);
  };

  return (
    <>
      <Box onClick={handleOpen}>
        <DeleteIcon />
      </Box>
      <DialogBox
        Header={t("COMMON004")}
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={handleClose}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid item>
            <DeleteIcon width="60px" height="50px" />
          </Grid>
          <Grid
            item
            style={{
              opacity: 1,
              textAlign: "center",
              display: "flex",
              flexDirection: "row",
              fontSize: "17px",
              marginTop: "15px",
              color: darkMode ? "#fff" : "#242424",
            }}
          >
            <Typography
              style={{
                fontSize: "15px",
                whiteSpace: "pre-line",
              }}
            >
              {t("COMMON018")}
            </Typography>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
